
import { computed, defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import Snackbar from "./components/Snackbar.vue";
import { useStore } from "./store";
export default defineComponent({
  name: "App",
  components: { Snackbar },
  setup() {
    const router = useRouter();
    const store = useStore();

    const isLoggedIn = computed(() => store.getters.isUserLoggedIn);
    const isAdmin = computed(() => store.getters.getUser.isAdmin);

    const profileLink = computed(
      () => `/users/${store.getters.getUser.userId}`
    );

    const toggleNavBar = () => {
      navBarIsActive.value = !navBarIsActive.value;
    };

    /**
     * Closing navbar when the active view is changed
     */
    router.afterEach((to, from, failure) => {
      if (to.fullPath !== from.fullPath) {
        navBarIsActive.value = false;
      }
    });

    const navBarIsActive = ref(false);

    const closeNavBar = () => {
      navBarIsActive.value = false;
    };

    /**
     * Logs user out through store
     * Sends user to log in page
     */
    const logout = () => {
      store.dispatch("logout");
      router.replace("/log-in");
    };

    return {
      logout,
      profileLink,
      navBarIsActive,
      toggleNavBar,
      isAdmin,
      isLoggedIn,
      closeNavBar,
    };
  },
});
